import React, { Component } from 'react'

// ui
import Pagination from '../../../components/uielements/pagination'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

class Paginate extends Component {
    onShowSizeChange = (current, pageSize) => {
        this.props.changePageSize(pageSize)
    }

    onChange(pageNumber) {
        this.props.changePageIndex(pageNumber)
    }

    render() {
        const { total, pageSize, pageIndex } = this.props
        return (
            <div className="PaginateContainer">
                <Pagination
                    showSizeChanger
                    onShowSizeChange={(current, pageSize) => this.onShowSizeChange(current, pageSize)}
                    onChange={(pageNumber) => this.onChange(pageNumber)}
                    current={pageIndex}
                    pageSizeOptions={['2', '6', '8', '10']}
                    total={total}
                    showQuickJumper
                    pageSize={pageSize}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        total: state.qbreport.total,
        pageSize: state.qbreport.pageSize,
        pageIndex: state.qbreport.pageIndex
    }
}

const mapDispatchToProps = dispatch =>{
    return {
        changePageSize: pageSize => {
            dispatch(ReportActions.action.updatePageSize(pageSize))
        },
        changePageIndex: pageIndex => {
            dispatch(ReportActions.action.updatePageIndex(pageIndex))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Paginate)
